import { ContactModal } from "../components/ContactModal";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { useContactModal } from "../context/contactModal";
import { JOBS } from "../data/jobs";
export const CareersPage = () => {
  const { isOpen, closeModal } = useContactModal();
  return (
    <div className="min-h-screen bg-[#131313]">
      <Header />
      <main>
        <section className="pt-48 pb-20 bg-[#131313] text-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">Join Our Team</h1>
              <p className="text-xl text-gray-400">
                Help us build the U.S.-based data infrastructure layer for Physical AI, robotics foundation
                models, and real-world robot deployment.
              </p>
            </div>
          </div>
        </section>
        <section className="py-20 bg-[#131313] text-white">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="mb-16">
                <h2 className="text-2xl font-bold mb-6">Why Actrium AI?</h2>
                <div className="grid md:grid-cols-2 gap-6">
                  <div className="bg-gray-800/50 rounded-xl p-6">
                    <h3 className="text-lg font-semibold mb-3">Cutting-Edge Research</h3>
                    <p className="text-gray-400 text-base">
                      Work on the frontier of Embodied AI with world-class researchers and engineers
                    </p>
                  </div>
                  <div className="bg-gray-800/50 rounded-xl p-6">
                    <h3 className="text-lg font-semibold mb-3">Real-World Impact</h3>
                    <p className="text-gray-400 text-base">
                      Your work will directly advance robotic dexterity in factories, homes, and beyond
                    </p>
                  </div>
                  <div className="bg-gray-800/50 rounded-xl p-6">
                    <h3 className="text-lg font-semibold mb-3">Competitive Compensation</h3>
                    <p className="text-gray-400 text-base">
                      Attractive salary, equity, and comprehensive benefits package
                    </p>
                  </div>
                  <div className="bg-gray-800/50 rounded-xl p-6">
                    <h3 className="text-lg font-semibold mb-3">Flexible Work</h3>
                    <p className="text-gray-400 text-base">
                      U.S.-based team culture with flexible collaboration and optional office access in New
                      York
                    </p>
                  </div>
                </div>
              </div>
              <div className="mb-16">
                <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
                  <div>
                    <p className="mb-3 text-base font-bold uppercase tracking-[0.18em] text-[#B3C9FE]">
                      Open Roles
                    </p>
                    <h2 className="text-3xl md:text-4xl font-bold">Roles We Are Hiring For</h2>
                  </div>
                  <p className="max-w-2xl text-base text-gray-400">
                    We are looking for people who can work with real physical data, robotics systems, and
                    high-quality review standards. U.S.-based candidates are preferred.
                  </p>
                </div>
                <div className="space-y-6">
                  {JOBS.map((n) => (
                    <article
                      className="rounded-md border border-white/10 bg-white/[0.04] p-6 md:p-8"
                      key={n.title}
                    >
                      <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
                        <div>
                          <h3 className="text-2xl font-bold text-white">{n.title}</h3>
                          <p className="mt-2 text-base text-[#B3C9FE]">{n.meta}</p>
                        </div>
                        <a
                          href={`mailto:vlado@actrium.ai?subject=${encodeURIComponent(`Application: ${n.title}`)}`}
                          className="inline-flex w-fit items-center justify-center rounded-md bg-[#006AFF] px-5 py-3 text-base font-bold text-white transition-colors hover:bg-[#0057D6]"
                        >
                          Apply
                        </a>
                      </div>
                      <p className="mb-6 max-w-4xl text-base leading-relaxed text-gray-300">{n.summary}</p>
                      <div className="grid gap-6 lg:grid-cols-2">
                        <div>
                          <h4 className="mb-3 text-base font-bold text-white">What You Will Do</h4>
                          <ul className="space-y-3">
                            {n.responsibilities.map((r) => (
                              <li className="flex gap-3 text-base leading-relaxed text-gray-400" key={r}>
                                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#006AFF]" />
                                <span>{r}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                        <div>
                          <h4 className="mb-3 text-base font-bold text-white">What We Are Looking For</h4>
                          <ul className="space-y-3">
                            {n.requirements.map((r) => (
                              <li className="flex gap-3 text-base leading-relaxed text-gray-400" key={r}>
                                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#006AFF]" />
                                <span>{r}</span>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </article>
                  ))}
                </div>
              </div>
              <div className="text-center py-12 rounded-md border border-white/10 bg-white/5 px-6">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-gray-800/50 rounded-md mb-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-8 w-8 text-gray-500"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.5}
                      d="M16 7a4 4 0 0 1-8 0M12 14v7M8 21h8M6 11h12a2 2 0 0 1 2 2v1a8 8 0 0 1-16 0v-1a2 2 0 0 1 2-2Z"
                    />
                  </svg>
                </div>
                <p className="text-white text-xl font-bold">Interested in joining our team?</p>
                <p className="text-gray-400 text-base mt-3 max-w-2xl mx-auto">
                  Send your resume, portfolio, or research profile to{" "}
                  <a
                    href="mailto:vlado@actrium.ai"
                    className="text-[#B3C9FE] hover:text-[#B3C9FE] transition-colors"
                  >
                    vlado@actrium.ai
                  </a>
                  . We are always open to strong engineers, researchers, designers, and operators who care
                  about Physical AI.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <ContactModal isOpen={isOpen} onClose={closeModal} />
    </div>
  );
};
